import React, { Fragment, useState } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import CustomerDetails from "./modal-components/customer-details";
import VehicleDetails from "./modal-components/vehicle-details";
import PolicyDetails from "./modal-components/policy-details";
import ProductDetails from "./modal-components/product-details";
import TaxDetails from "./modal-components/tax-details";
import { ModalFooter } from "react-bootstrap";
import CommunicationDetails from "./modal-components/communication-details";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import ClientDealership from "./modal-components/client-dealership-details";
import { useEffect } from "react";
import { getDocumentById, getPolicyDetailsById,getCashifyPolicyDetailsById } from "../../../../api";
import ChangeHistoryDetails from "./modal-components/change-history-details";
import GetLoader from "../../../common/getLoader";
import NomineeDetails from "./view-policy-modals/nominee-details";
import CashifyPolicyUserDetails from "./view-policy-modals/cashify-policy-user-details";
import CashifyPolicySubModalDetails from "./view-policy-modals/cashify-policy-details";
import TravellerDetails from "./view-policy-modals/traveller-details";


const ViewCashifyPolicyModal = ({ isOpen, toggle, selectedPolicyData, selectedTicketData }) => {
    const [viewPolicyDetailsByType, setViewPolicyDetailsByType] = useState(0);
    const [loading, setLoading] = useState(false);
    const [documentDetails, setDocumentDetails] = useState({});
    const steps = [
        { key: 0, name: 'User Details', component: <CashifyPolicyUserDetails data={documentDetails} /> },
        { key: 1, name: 'Document Details', component: <CashifyPolicySubModalDetails data={documentDetails} /> },
        // { key: 2, name: 'Nominee', component: <NomineeDetails data={documentDetails} /> },
        // { key: 3, name: 'Plan', component: <PlanDetails data={documentDetails} /> },
        // { key: 0, name: 'Customer', component: <CustomerDetails data={policyData} /> },
        // { key: 1, name: 'Dealership', component: <ClientDealership data={documentDetails} /> },
        // { key: 2, name: 'Vehicle', component: <VehicleDetails data={documentDetails} /> },
        // { key: 3, name: 'Policy', component: <PolicyDetails data={documentDetails} /> },
        // { key: 4, name: 'Product', component: <ProductDetails data={documentDetails} /> },
        // { key: 5, name: 'Tax', component: <TaxDetails data={documentDetails} /> },

    ]

    // Check if policyData.communication exists and its length is not equal to 0
    // if (policyData.communication && policyData.communication.length !== 0) {
    //     steps.push({ key: 6, name: 'Communication', component: <CommunicationDetails data={policyData} /> });
    // }

    // Check if policyData.communication exists and its length is not equal to 0
    if (selectedTicketData && selectedTicketData.length !== 0) {
        steps.push({ key: 7, name: 'History', component: <ChangeHistoryDetails data={selectedTicketData} isHistoryTabTrigger={true} /> },);
    }


    console.log("selectedPolicyData in cashify modal", selectedTicketData);
    const handleNextTabByClick = (nextStepValue, steps) => {
        if (nextStepValue < steps.length) {
            // console.log(viewPolicyDetailsByType, 'viewPolicyDetailsByType');
            setViewPolicyDetailsByType(viewPolicyDetailsByType + 1);
        }
    }

    const handlePreviousTabByClick = (previousStepValue, steps) => {
        if (previousStepValue >= 0) {
            setViewPolicyDetailsByType(viewPolicyDetailsByType - 1);
        }
    }

    // let sales_policy_id;
    // if (selectedPolicyData?.policy?.sales_policy_id) {
    //     sales_policy_id = selectedPolicyData?.policy?.sales_policy_id
    // } else if (selectedPolicyData?.sales_policy_id) {
    //     sales_policy_id = selectedPolicyData?.sales_policy_id
    // }

    const fetchDocumentDetails = async () => {
        setLoading(true);
        try {
                const document_id = selectedPolicyData?.policy_id;
                const response = await getCashifyPolicyDetailsById(document_id);
                if (response && response.data) {
                    console.log("response.data EXISTS and is:", response.data?.result?.policy[0]);
                    setDocumentDetails(response.data?.result?.policy[0]);
                    selectedTicketData.cancelledBy = response.data?.result?.cancelled_by;
                    selectedTicketData.policyStatus = response.data?.result?.policy[0]?.status;
                } else {
                    console.log("response.data is MISSING or null/undefined. Full response:", response);
                }
                
        } catch (err) {
            console.error(err);
        } finally {
            console.log("here is res")
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchDocumentDetails();
    }, []);

    return (
        <Fragment>

            <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
                <ModalHeader toggle={toggle} className="pb-0 border-0">
                    {"Policy Details"}
                </ModalHeader>
                <ModalBody className="pt-4">

                    {loading ? <GetLoader /> : (
                        <>

                            <Nav className="nav-pills nav-justified">
                                {
                                    steps && steps.map((item, i) => {
                                        return (
                                            <NavItem key={i}>
                                                <NavLink href="#javascript" className={viewPolicyDetailsByType === item.key ? 'active' : ''} onClick={() => setViewPolicyDetailsByType(item.key)}>
                                                    <span style={{ whiteSpace: 'nowrap' }}> {item.name} </span>
                                                </NavLink>
                                            </NavItem>
                                        )
                                    })
                                }
                            </Nav>
                            <TabContent activeTab={viewPolicyDetailsByType}>
                                {
                                    steps && steps.map((item, i) => {
                                        return (
                                            <TabPane className={item.key === 0 ? "fade show" : ""} tabId={item.key} key={i}>
                                                {item.component}
                                            </TabPane>
                                        )
                                    })
                                }
                            </TabContent>
                        </>

                    )}

                </ModalBody>
                <ModalFooter>
                    <div className="container-fluid">
                        <div className="row">
                        <div className="col-6">
                        {parseInt(viewPolicyDetailsByType) !== 0 && (
                            <Button
                            className="mr-2 btnCustom"
                            outline
                            color="info"
                            size="md"
                            onClick={(e) => handlePreviousTabByClick(parseInt(viewPolicyDetailsByType) - 1, steps)}
                            >
                            {"Previous"}
                            </Button>
                            )}
                        </div>
                        <div className="col-6 text-right">
                            {parseInt(viewPolicyDetailsByType) < steps.length - 1 && (
                            <Button
                                className="btnCustom"
                                outline
                                color="info"
                                size="md"
                                onClick={(e) => handleNextTabByClick(parseInt(viewPolicyDetailsByType) + 1, steps)}
                            >
                                {"Next"}
                            </Button>
                            )}
                        </div>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

export default ViewCashifyPolicyModal;
